import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Provajder } from './provajder';

@Component({
  selector: 'yt-provajder-modal-update',
  templateUrl: './provajder-modal-update.component.html'
})
export class ProvajderModalUpdateComponent extends BaseModalUpdateComponent<Provajder> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Provajder>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
 

  ngOnInit() {
  }

}
